import { createContext } from 'react';

type AutosaveContextType = {
  isAutoSaveModalOpen: boolean;
  isAutosaveCacheEnabled: () => boolean;
  closeAutoSaveModal: () => void;
  resumeAutoSave: () => void;
  removeAutosaveCache: () => void;
};

const defaultAutosaveContext: AutosaveContextType = {
  isAutoSaveModalOpen: false,
  isAutosaveCacheEnabled: () => false,
  closeAutoSaveModal: () => {},
  resumeAutoSave: () => {},
  removeAutosaveCache: () => {},
};

export const AutosaveContext = createContext<AutosaveContextType>(defaultAutosaveContext);
